import { FarmRegistrationState } from "@/store/farmRegistration/state";
import { GetterTree } from "vuex";
import { RootState } from "@/@types/vuex";

export const getters: GetterTree<FarmRegistrationState, RootState> = {
  getPendingTasks: ({ tasks }) => tasks.PENDING,
  getRegisteredTasks: ({ tasks }) => tasks.REGISTERED,
};
